var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556,
    height: 608,
    viewBox: "0 0 556 608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23613",
    "data-name": "Path 23613",
    d: "M0,0H29.579V22.184H0Z",
    fill: "rgba(0,0,0,0.7)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14230",
    "data-name": "Group 14230",
    transform: "translate(7788 7797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3892",
    "data-name": "Rectangle 3892",
    transform: "translate(-7788 -7797)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 608,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 555,
    height: 607,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3893",
    "data-name": "Rectangle 3893",
    width: 556,
    height: 68,
    transform: "translate(-7788 -7513)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3894",
    "data-name": "Rectangle 3894",
    width: 556,
    height: 63,
    transform: "translate(-7788 -7387)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3895",
    "data-name": "Rectangle 3895",
    width: 556,
    height: 63,
    transform: "translate(-7788 -7267)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3896",
    "data-name": "Rectangle 3896",
    width: 496,
    height: 1,
    transform: "translate(-7758 -7629)",
    fill: "#dae2d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3897",
    "data-name": "Rectangle 3897",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7513)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3898",
    "data-name": "Rectangle 3898",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7446)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3899",
    "data-name": "Rectangle 3899",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7387)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3900",
    "data-name": "Rectangle 3900",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7325)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3901",
    "data-name": "Rectangle 3901",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7267)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14228",
    "data-name": "Group 14228",
    transform: "translate(-7392.001 -7502)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Available:_5_000.00",
    "data-name": "Available: $ 5,000.00",
    transform: "translate(130.001 40)",
    fill: "#111",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -139.524,
    y: 0
  }, "Available: $"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.2em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "5,000.00")), /*#__PURE__*/React.createElement("text", {
    id: "_0.76_USD",
    "data-name": "0.76 USD",
    transform: "translate(94.001 17)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.68,
    y: 0
  }, "0.76 USD")), /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(103.378 2.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 26.623,
    height: 16.468,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 26.623,
    height: 2.122,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 4.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 8.149)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 14.345)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 12.223)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 13.724,
    height: 9.853,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.394 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.3,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.52,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-79.342 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.158,207.077l-.221-.68-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-26.001 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M26.937,160.624l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.3,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.937,114.85l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.661,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.882,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-132.682 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.245,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-186.024 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.024,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.661,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.024,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -114.85)",
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "USD_SGD_0.761_Inverse_1.314_16_Oct_2022_09:17_PM_08:00_16_Oct_2022_0.003_SGD_0.3_",
    "data-name": "USD/SGD 0.761 (Inverse 1.314) 16 Oct 2022 09:17 PM (+08:00) 16 Oct 2022  0.003 SGD (0.3%)",
    transform: "translate(-7262 -7412)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -235.328,
    y: 0
  }, "USD/SGD 0.761 (Inverse 1.314)"), /*#__PURE__*/React.createElement("tspan", {
    x: -236.4,
    y: 61
  }, "16 Oct 2022 09:17 PM (+08:00)"), /*#__PURE__*/React.createElement("tspan", {
    x: -93.744,
    y: 122
  }, "16 Oct 2022 "), /*#__PURE__*/React.createElement("tspan", {
    x: -138.736,
    y: 183
  }, "0.003 SGD (0.3%)")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14229",
    "data-name": "Group 14229",
    transform: "translate(-7394.001 -7572)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Available:_21_600.76",
    "data-name": "Available: $ 21,600.76",
    transform: "translate(132.001 40)",
    fill: "#111",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -142.31,
    y: 0
  }, "Available: $"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.2em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "21,600.76")), /*#__PURE__*/React.createElement("text", {
    id: "_1_SGD",
    "data-name": "1 SGD",
    transform: "translate(96.001 16)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.104,
    y: 0
  }, "1 SGD")), /*#__PURE__*/React.createElement("g", {
    id: "sg",
    transform: "translate(102.423 0.408)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23609",
    "data-name": "Path 23609",
    d: "M-20,0H13.276V22.184H-20Z",
    transform: "translate(19.076)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23610",
    "data-name": "Path 23610",
    d: "M-20,0H13.276V11.092H-20Z",
    transform: "translate(19.076)",
    fill: "#df0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23611",
    "data-name": "Path 23611",
    d: "M41.988,37.04a3.9,3.9,0,0,0,.037,7.635,3.968,3.968,0,1,1-2.2-7.626,3.8,3.8,0,0,1,2.168-.009Z",
    transform: "translate(-35.24 -35.182)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23612",
    "data-name": "Path 23612",
    d: "M105.34,53.918l.226.693-.6-.425-.592.434.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.809,2.4.231.7-.6-.425-.6.43.222-.7-.592-.434.735,0,.226-.7.231.693h.739Zm2.7-.018.226.7-.6-.43-.592.43.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.8-2.385.226.7-.6-.425-.592.43.222-.7-.6-.434.739,0,.222-.7.231.693h.739Zm-2.14-1.585.231.7-.6-.43-.6.434.222-.7-.592-.434.73,0,.231-.7.231.693h.739Z",
    transform: "translate(-99.193 -48.834)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Your_conversion_has_been_created",
    "data-name": "Your conversion has been created",
    transform: "translate(-7502 -7689)",
    fill: "#111",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -204.78,
    y: 0
  }, "Your conversion has been created")), /*#__PURE__*/React.createElement("text", {
    id: "Conversion_ID:_C221111-7AFQLZ4",
    "data-name": "Conversion ID: C221111-7AFQLZ4",
    transform: "translate(-7502 -7654.596)",
    fill: "#777",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -124.624,
    y: 0
  }, "Conversion ID: "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#111",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, "C221111-7AFQLZ4")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14231",
    "data-name": "Group 14231",
    transform: "translate(37.734 94.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14225",
    "data-name": "Group 14225",
    transform: "translate(-7561.735 -7861.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_023-label",
    "data-name": "023-label",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(1.328 1.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7667",
    "data-name": "Group 7667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M28.612,8.711,32.156,7.1a3.9,3.9,0,0,1,5.266,2.181l1.368,3.645a3.9,3.9,0,0,0,2.282,2.282l3.645,1.368A3.9,3.9,0,0,1,46.9,21.842l-1.611,3.544a3.9,3.9,0,0,0,0,3.227L46.9,32.156a3.9,3.9,0,0,1-2.181,5.266L41.072,38.79a3.9,3.9,0,0,0-2.282,2.282l-1.368,3.645A3.9,3.9,0,0,1,32.156,46.9l-3.544-1.611a3.9,3.9,0,0,0-3.227,0L21.842,46.9a3.9,3.9,0,0,1-5.266-2.181l-1.368-3.645a3.9,3.9,0,0,0-2.282-2.282L9.281,37.422A3.9,3.9,0,0,1,7.1,32.156l1.611-3.544a3.9,3.9,0,0,0,0-3.227L7.1,21.842a3.9,3.9,0,0,1,2.181-5.266l3.645-1.368a3.9,3.9,0,0,0,2.282-2.282l1.368-3.645A3.9,3.9,0,0,1,21.842,7.1l3.544,1.611A3.9,3.9,0,0,0,28.612,8.711Z",
    transform: "translate(-6.749 -6.749)",
    fill: "#00cf15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7671",
    "data-name": "Group 7671",
    transform: "translate(22.331 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7668",
    "data-name": "Group 7668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M19.531,8.682a3.846,3.846,0,0,0,3.184,0L25.758,7.3a3.825,3.825,0,0,0-3.544-.2l-3.09,1.4Z",
    transform: "translate(-19.124 -6.753)",
    fill: "#00cf75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7670",
    "data-name": "Group 7670",
    transform: "translate(0.004 38.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M22.715,28.312a3.846,3.846,0,0,0-3.184,0l-.4.185,3.09,1.4a3.83,3.83,0,0,0,3.544-.2Z",
    transform: "translate(-19.126 -27.967)",
    fill: "#00cf75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "line",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7676",
    "data-name": "Group 7676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M20.813,49.153a5.238,5.238,0,0,1-4.911-3.4l-1.367-3.64a2.553,2.553,0,0,0-1.493-1.493L9.4,39.254A5.243,5.243,0,0,1,6.47,32.172L8.08,28.633a2.554,2.554,0,0,0,0-2.109L6.472,22.985A5.246,5.246,0,0,1,9.4,15.9l3.641-1.365a2.552,2.552,0,0,0,1.491-1.491L15.9,9.4a5.246,5.246,0,0,1,7.083-2.931l3.539,1.609a2.561,2.561,0,0,0,2.109,0l3.541-1.609a5.243,5.243,0,0,1,7.082,2.933l1.367,3.64a2.55,2.55,0,0,0,1.491,1.493l3.64,1.365a5.243,5.243,0,0,1,2.933,7.082l-1.609,3.541a2.554,2.554,0,0,0,0,2.109l1.608,3.541a5.244,5.244,0,0,1-2.931,7.082l-3.642,1.365a2.547,2.547,0,0,0-1.491,1.491l-1.367,3.641a5.246,5.246,0,0,1-7.083,2.931l-3.539-1.609a2.554,2.554,0,0,0-2.109,0l-3.541,1.608a5.221,5.221,0,0,1-2.169.469Zm0-40.459a2.558,2.558,0,0,0-2.388,1.656L17.06,13.992a5.245,5.245,0,0,1-3.07,3.07l-3.64,1.363a2.55,2.55,0,0,0-1.426,3.442l1.609,3.539a5.24,5.24,0,0,1,0,4.341L8.925,33.287a2.549,2.549,0,0,0,1.426,3.44l3.64,1.365a5.236,5.236,0,0,1,3.07,3.07l1.367,3.64a2.549,2.549,0,0,0,3.44,1.426l3.541-1.609a5.242,5.242,0,0,1,4.339,0l3.541,1.609A2.55,2.55,0,0,0,36.73,44.8L38.1,41.16a5.245,5.245,0,0,1,3.07-3.07l3.641-1.365a2.549,2.549,0,0,0,1.426-3.44l-1.609-3.541a5.24,5.24,0,0,1,0-4.341l1.609-3.541a2.55,2.55,0,0,0-1.426-3.442l-3.64-1.365a5.245,5.245,0,0,1-3.07-3.07l-1.367-3.64a2.549,2.549,0,0,0-3.44-1.426L29.751,10.53a5.249,5.249,0,0,1-4.339,0L21.871,8.921a2.6,2.6,0,0,0-1.056-.227Z",
    transform: "translate(-6.001 -6.004)",
    fill: "#009e15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M4.6,14.486l-4.4-4.4a.678.678,0,0,1,0-.958l.958-.958a.678.678,0,0,1,.958,0l2.967,2.967,6.356-6.356a.678.678,0,0,1,.958,0l.958.958a.678.678,0,0,1,0,.958L5.562,14.486A.678.678,0,0,1,4.6,14.486Z",
    transform: "translate(15.189 11.945)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "From_currency",
    "data-name": "From currency",
    transform: "translate(-7759 -7544)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "From currency")), /*#__PURE__*/React.createElement("text", {
    id: "To_currency",
    "data-name": "To currency",
    transform: "translate(-7759 -7474)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "To currency")), /*#__PURE__*/React.createElement("text", {
    id: "Exchange_rate_Settlement_date_Delivery_date_PayStreet_fee",
    "data-name": "Exchange rate Settlement date Delivery date PayStreet fee",
    transform: "translate(-7759 -7411)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exchange rate"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 61
  }, "Settlement date"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 122
  }, "Delivery date"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183
  }, "PayStreet fee")), /*#__PURE__*/React.createElement("text", {
    id: "Conversion_summary",
    "data-name": "Conversion summary",
    transform: "translate(-7759 -7590)",
    fill: "#176b41",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversion summary")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertImage1);
export default __webpack_public_path__ + "static/media/convert-image-1.a78ea0357d9c9a9c991f91ecb5e3fab4.svg";
export { ForwardRef as ReactComponent };